import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const LockScreen = () => {
    const [password, setPassword] = useState("");
    const move = useNavigate();
    const navigate = () => {
        if (password.length > 0) {
            if (password === process.env.REACT_APP_WEBSITE_PASSWORD) {
                localStorage.setItem("isValidUser", true)
                move('/home');
            } else {
                window.alert("Wrong password");
                localStorage.setItem("isValidUser", false)
            }
        }
    };
    function handleSubmit(event) {
        event.preventDefault();
    }
    useEffect(() => {
        localStorage.setItem("isValidUser", false)
    }, []);
    return (
        <section className="slider-area slider-bg lock-screen">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-9">
                        <div className="slider-content text-center">
                            <h6 className="wow fadeInDown" data-wow-delay=".2s">Access Restricted !!</h6>
                            <h2 className="tlt fix" data-in-effect="fadeInLeft">Safe <span>Moon</span></h2>
                              
                            <div className="sidebar-search mt-5">
                                <form action="/#" onSubmit={handleSubmit}>
                                    <input type="password" placeholder="Please Enter The Password"  onChange={(e) => setPassword(e.target.value)} />
                                    
                                </form>
                                <button
                                    className="btn wow fadeInUp mt-5"
                                    onClick={() => navigate()}
                                >
                                    Start
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

//make this component available to the app
export default LockScreen;
